/**
 * Format a number as USD currency
 */
export function formatCurrency(amount, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
    }).format(amount);
}
/**
 * Format a number with commas
 */
export function formatNumber(num) {
    return new Intl.NumberFormat('en-US').format(num);
}
/**
 * Truncate a string to a maximum length
 */
export function truncate(str, maxLength, suffix = '...') {
    if (str.length <= maxLength)
        return str;
    return str.slice(0, maxLength - suffix.length) + suffix;
}
/**
 * Generate a URL-friendly slug from a string
 */
export function slugify(str) {
    return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
/**
 * Capitalize the first letter of a string
 */
export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Convert bytes to human-readable size
 */
export function formatFileSize(bytes) {
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let unitIndex = 0;
    let size = bytes;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}
/**
 * Format an order number
 */
export function formatOrderNumber(id) {
    const year = new Date().getFullYear();
    const shortId = id.slice(0, 8).toUpperCase();
    return `OO-${year}-${shortId}`;
}
/**
 * Generate initials from a name
 */
export function getInitials(name) {
    return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
}
/**
 * Pluralize a word based on count
 */
export function pluralize(count, singular, plural) {
    if (count === 1)
        return singular;
    return plural || `${singular}s`;
}
